import { render, staticRenderFns } from "./workshops.vue?vue&type=template&id=13f821f1&scoped=true"
import script from "./workshops.vue?vue&type=script&lang=js"
export * from "./workshops.vue?vue&type=script&lang=js"
import style0 from "./workshops.vue?vue&type=style&index=0&id=13f821f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f821f1",
  null
  
)

export default component.exports